module.exports = __webpack_public_path__ + "static/media/vitalInsuranceDeductible.8d6cfd72.png";